import { render, staticRenderFns } from "./SkillCard.vue?vue&type=template&id=335dc28b&scoped=true"
import script from "./SkillCard.vue?vue&type=script&lang=js"
export * from "./SkillCard.vue?vue&type=script&lang=js"
import style0 from "./SkillCard.vue?vue&type=style&index=0&id=335dc28b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335dc28b",
  null
  
)

export default component.exports